import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { EclipseOfferingApiClient } from '../../api-clients';
const {
  Provider,
  context,
  ...client
} = EclipseOfferingApiClient;
export const EclipseOfferingApiExtension = createModuleExtension({
  extensionName: 'eclipseOfferingApiExtension',
  Provider,
  SDK: {
    eclipseOfferingApiClient: client,
    eclipseOfferingContext: context
  }
});
//# sourceMappingURL=eclipse-offering.extension.js.map